import ApiProcessor from '@lib/processors/api-processor'

const TABLE_FILTERS = []

const TABLE_COLUMNS = [
  {
    name: 'created_at',
    label: 'Date Created',
    format: 'dateTime',
    icon: 'el-icon-date',
    width: 150,
  },
  {
    name: 'product_id',
    label: 'ID',
    icon: 'el-icon-document',
  },
  {
    name: 'payload.name',
    label: 'Name',
    icon: 'el-icon-document',
  },
]

export default component => ({
  processor: new ApiProcessor({
    component,
    path: `/providers/${component.publishing.provider_id}/published-products/updated`,
    initialDataQuery: {
      defaultSort: {
        createdAt: 'desc',
      },
    },
  }),
  filters: TABLE_FILTERS,
  columns: TABLE_COLUMNS,
  tableName: 'new-published-products',
})
